import React, { useEffect, useState } from "react";
import MetaData from "../layout/MetaData";
import { useOrderDetailsQuery } from "../../redux/api/orderApi";
import { Link, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import Loader from "../layout/Loader";

const OrderDetails = () => {
    const [showProof, setShowProof] = useState(false);
    const params = useParams();
    const { data, isLoading, error } = useOrderDetailsQuery(params?.id);

    const order = data?.order || {};
    const { shippingInfo, orderItems, paymentInfo, user, totalAmount, orderStatus } = order;
    const isPaid = paymentInfo?.status === "paid";

    useEffect(() => {
        if (error) toast.error(error?.data?.message);
    }, [error]);

    if (isLoading) return <Loader />;

    return (
        <>
            <MetaData title="Order Details" />

            <div className=" container my-5" style={{ minHeight: "80vh", paddingTop: "100px", paddingBottom: "40px" }}>
                <div className=" card border-0 shadow-sm rounded-4 p-4">
                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2 className="fw-bold text-gradient" style={{ color: "#e04f6ecd" }}>
                            Order Details
                        </h2>

                        {/* 🧾 Invoice button with same gradient as Add to Cart */}
                        <Link
                            to={`/invoice/order/${order?._id}`}
                            className="btn View-btn"
                        >
                            <i className="fa fa-print"></i> Invoice
                        </Link>
                    </div>

                    {/* Order Info */}
                    <div className="mb-4">
                        <h5 className="fw-semibold text mb-3" style={{ color: "#e04f6ecd" }}>Order Summary</h5>
                        <table className="table table-borderless mb-0">
                            <tbody>
                                <tr>
                                    <th style={{ width: "150px", color: "#e04f6ecd" }}>Order ID:</th>
                                    <td style={{ color: "#e04f6ecd" }}>{order?._id}</td>
                                </tr>
                                <tr>
                                    <th style={{ color: "#e04f6ecd" }}>Status:</th>
                                    <td
                                        className={String(orderStatus).includes("Delivered") ? "text-success" : "text-danger"}
                                    >
                                        <b > {orderStatus}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <th style={{ color: "#e04f6ecd" }}>Date:</th>
                                    <td style={{ color: "#e04f6ecd" }}>{new Date(order?.createdAt).toLocaleString("en-US")}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Shipping Info */}
                    <div className="mb-4">
                        <h5 className="fw-semibold text mb-3" style={{ color: "#e04f6ecd" }}>Shipping Info</h5>
                        <table className="table table-borderless mb-0">
                            <tbody>
                                <tr>
                                    <th style={{ width: "150px", color: "#e04f6ecd" }}>Name:</th>
                                    <td style={{ color: "#e04f6ecd" }}> {user?.name}</td>
                                </tr>
                                <tr>
                                    <th style={{ color: "#e04f6ecd" }}>Phone No:</th>
                                    <td style={{ color: "#e04f6ecd" }}>{shippingInfo?.phoneNo}</td>
                                </tr>
                                <tr>
                                    <th style={{ color: "#e04f6ecd" }}>Address:</th>
                                    <td style={{ color: "#e04f6ecd" }}>
                                        {shippingInfo?.address}, {shippingInfo?.city}, {shippingInfo?.zipCode},{" "}
                                        {shippingInfo?.country}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Payment Info */}
                    <div className="mb-4">
                        <h5 className="fw-semibold text mb-3" style={{ color: "#e04f6ecd" }}>Payment Details</h5>
                        <table className="table table-borderless mb-0">
                            <tbody>
                                <tr>
                                    <th style={{ width: "150px", color: "#e04f6ecd"  }}>Status:</th>
                                    <td className={isPaid ? "text-success" : "text-danger"}>
                                        <b>{paymentInfo?.status?.toUpperCase()}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <th style={{ color: "#e04f6ecd" }}>Method:</th>
                                    <td style={{ color: "#e04f6ecd" }}>{order?.paymentMethod}</td>
                                </tr>
                                <tr>
                                    <th style={{ color: "#e04f6ecd" }}>Amount Paid:</th>
                                    <td>
                                        <b style={{ color: "#e04f6ecd" }}>PKR {totalAmount}</b>
                                    </td>
                                </tr>
                                {order?.paymentMethod === 'JazzCash' && paymentInfo?.screenshot && (
                                    <tr>
                                        <th style={{ color: "#e04f6ecd" }}>Proof:</th>
                                        <td>
                                            <button
                                                className="btn View-btn btn-sm fw-semibold"
                                                onClick={() => setShowProof(true)}
                                            >
                                                View JazzCash Proof
                                            </button>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Order Items */}
                    <div>
                        <h5 className="fw-semibold text mb-3" style={{ color: "#e04f6ecd" }}>Order Items</h5>
                        {orderItems?.map((item, index) => (
                            <div
                                key={index}
                                className="d-flex align-items-center  rounded-4 p-3 mb-3 bg-white shadow-sm"
                            >
                                <img
                                    src={item?.image}
                                    alt={item?.name}
                                    height="70"
                                    width="70"
                                    className="rounded-3 me-3"
                                />
                                <div className="flex-grow-1">
                                    <Link
                                        to={`/product/${item?.product}`}
                                        className="fw-semibold text-decoration-none"
                                        style={{ color: "#e04f6ecd" }}
                                    >
                                        {item?.name}
                                    </Link>
                                    {item?.variant?.name ? (
                                        <div className="small text" style={{ color: "#c56f86" }}>
                                            Variant: <span className="fw-semibold">{item.variant.name}</span>
                                        </div>
                                    ) : null}
                                    {Array.isArray(item?.colors) && item.colors.length > 0 ? (
                                        <div className="small text" style={{ color: "#c56f86" }}>Selected: <span className="fw-semibold">{item.colors.join(", ")}</span></div>
                                    ) : item?.color ? (
                                        <div className="small text" style={{ color: "#c56f86" }}>Selected: <span className="fw-semibold">{item.color}</span></div>
                                    ) : null}
                                    <div className="text small mt-1" style={{ color: "#e04f6ecd" }}>
                                        {item?.quantity} × PKR {item?.price}
                                    </div>
                                </div>
                                <div className="fw-semibold text " style={{ color: "#e91e63" }}>
                                    PKR {item?.price * item?.quantity}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {showProof && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{ background: "rgba(0,0,0,0.6)", zIndex: 1050 }}
                    onClick={() => setShowProof(false)}
                >
                    <div
                        className="bg-white rounded-4 shadow p-3"
                        style={{ maxWidth: "90%", maxHeight: "90%" }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="m-0 fw-bold" style={{ color: "#e04f6ecd" }}>JazzCash Screenshot</h6>
                            <button className="btn btn-sm btn-outline-secondary" onClick={() => setShowProof(false)}>Close</button>
                        </div>
                        <div className="text-center">
                            <img
                                src={paymentInfo?.screenshot}
                                alt="JazzCash Proof"
                                className="img-fluid rounded-3"
                                style={{ maxHeight: "75vh", objectFit: "contain" }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default OrderDetails;